module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ((typeof _vm.$teras.evento.id != 'undefined')) ? _c('div', {
    staticClass: "nl-edit"
  }, [_c('el-form', {
    ref: "isAbs",
    attrs: {
      "model": _vm.$abs.row,
      "rules": _vm.rules,
      "label-width": "180px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.preview.apply(null, arguments)
      }
    }
  }, [(!_vm.$teras.preview) ? _c('div', [(_vm.$abs.row.step == 0) ? _c('div', [_c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.lineeguidaSection)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row row-form"
  }, [_c('div', {
    staticClass: "col s10 offset-s2",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.evento.lineeguida)
    }
  })]), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0"
    },
    model: {
      value: (_vm.$abs.lineeguida),
      callback: function($$v) {
        _vm.$set(_vm.$abs, "lineeguida", $$v)
      },
      expression: "$abs.lineeguida"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.lineeguidaCheck)
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.datipresentatoreSection)
    }
  }), _vm._v(" "), (_vm.$abs.lineeguida > 0) ? _c('div', [_c('div', {
    staticClass: "row pad help"
  }, [_c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("live_help")])]), _vm._v(" "), _c('div', {
    staticClass: "col s10",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.datipresentatoreHelp)
    }
  })]), _vm._v(" "), _c('absPresentatore')], 1) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.affiliazioniSection)
    }
  }), _vm._v(" "), (_vm.$abs.row.prnome != '' && _vm.$abs.row.prcognome != '' && _vm.$abs.row.premail != '') ? _c('div', [_c('div', {
    staticClass: "row pad help"
  }, [_c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("live_help")])]), _vm._v(" "), _c('div', {
    staticClass: "col s10",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.affiliazioniHelp)
    }
  })]), _vm._v(" "), _c('absAffiliazioni')], 1) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.autoriSection)
    }
  }), _vm._v(" "), (_vm.$teras.affiliazioni.length > 0) ? _c('div', [_c('div', {
    staticClass: "row help"
  }, [_c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("live_help")])]), _vm._v(" "), _c('div', {
    staticClass: "col s10",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.autoriHelp)
    }
  })]), _vm._v(" "), (_vm.$teras.affiliazioni.length > 0) ? _c('absAutori') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.paSection)
    }
  }), _vm._v(" "), (_vm.$teras.autori.length > 0) ? _c('absPrimoautore') : _vm._e(), _vm._v(" "), (_vm.$teras.evento.poster == 1 || _vm.$teras.evento.comunicazione == 1) ? _c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.datiabsSection)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$abs.row.paemail != '' && _vm.$abs.row.pacellulare != '') ? _c('absPoster') : _vm._e(), _vm._v(" "), (_vm.$teras.evento.finanziamenti == 1) ? _c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.finanziamentiSection)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.finanziamenti == 1 && _vm.$abs.row.paemail != '' && _vm.$abs.row.pacellulare != '') ? _c('absFinanziamenti') : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.testoSection)
    }
  }), _vm._v(" "), (_vm.$abs.row.paemail != '' && _vm.$abs.row.pacellulare != '') ? _c('absTesto') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.previewSection)
    }
  }), _vm._v(" "), (_vm.$abs.row.wordcount > 1 && _vm.$abs.row.wordcount < _vm.$teras.evento.maxparole + 1) ? _c('div', [(!_vm.$teras.preview) ? _c('div', {
    staticClass: "row pad help"
  }, [_c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("live_help")])]), _vm._v(" "), _c('div', {
    staticClass: "col s10"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.previewHelp)
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "16px 0 0 0",
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onPreview
    }
  }, [_vm._v("Preview")])], 1)]) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "linkPreview",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "href": _vm.urlPreview,
      "target": "_blank"
    }
  }, [_vm._v("Preview")]), _vm._v(" "), _c('div', {
    staticClass: "row pad"
  }, [_c('div', {
    staticClass: "col s12 m4"
  }, [(_vm.$teras.preview) ? _c('div', {
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0 0 20px 0"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.previewCheckHelp)
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0"
    },
    model: {
      value: (_vm.preview),
      callback: function($$v) {
        _vm.preview = $$v
      },
      expression: "preview"
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.previewCheck))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.onChange
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.modifica))])], 1) : _vm._e(), _vm._v(" "), (_vm.preview > 0) ? _c('div', {
    staticStyle: {
      "margin": "80px 0"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0 0 20px 0"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.previewCheckedHelp)
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Save
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.salvainvia))])], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.preview && _vm.$abs.row.step == 1) ? _c('div', {
    staticStyle: {
      "margin": "80px 0"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveNoEmail
    }
  }, [_vm._v("SALVA SENZA INVIARE EMAIL")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m8"
  }, [(_vm.$teras.preview) ? _c('el-pdf', {
    attrs: {
      "pdfPath": _vm.$abs.urlPreview
    }
  }) : _vm._e()], 1)])]) : _vm._e()])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-091a5cf6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Abs-new.vue
// module id = 594
// module chunks = 2